<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="用户姓名：">
            <el-input v-model="query.realName" placeholder="请输入姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="用户手机号：">
            <el-input v-model="query.userPho" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="身份：">
            <el-select v-model="query.levelId" placeholder="请选择" clearable size="small">
              <el-option v-for="(item,index) in identityOptions" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程名称：">
            <el-input v-model="query.subjectName" placeholder="请输入课程名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="赠送原因：">
            <el-input v-model="query.reasonForGift" placeholder="请输入赠送原因" clearable size="small" />
            <!-- <el-select v-model="query.isEnable" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <!-- <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleDownload" icon="el-icon-plus">导出</el-button>
        </div>
      </div> -->
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="用户信息" prop="name" align="center" width="200">
          <template slot-scope="{row}">
            {{row.realName}}{{row.levelName?'('+row.levelName+')':''}}<br />{{row.userPho}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="课程名称" prop="subjectName" align="center" /> -->
        <el-table-column label="课程分类" prop="typeWelfareName" align="center" />
        <el-table-column label="赠送原因" prop="reasonForGift" align="center" />
        <el-table-column label="赠送时间" prop="createdTime" sortable="custom" align="center" />
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import courseOrderApi from '@/api/course/courseOrder'
import Pagination from '@/components/Pagination'
import customerLevelApi from '@/api/sys/customerLevel'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      activeName: '1',
      identityOptions: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    this.getIdentity()
  },
  methods: {
    getIdentity() {
      customerLevelApi.fetchList({ isEnable: true }).then((res) => {
        this.identityOptions = res.data
      })
    },
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.purchaseType = 2
      this.query.userType = this.query.levelId ? 20 : undefined
      this.listLoading = true
      return courseOrderApi.fetchList(this.query)
        .then(data => {
          let {list,total} = data.data;
          list.forEach(item => {
            let arr = []
            item.courseClassificationVOList.forEach(itt => {
              arr.push(itt.typeName + (itt.courseClassificationVO ? '>' + itt.courseClassificationVO.typeName : '') +
                (itt.courseClassificationVO && itt.courseClassificationVO.courseClassificationVO ? '>' + itt.courseClassificationVO.courseClassificationVO.typeName : ''))
            })
            item.className = arr.toString()
          });
          this.list = list
          this.total = total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleDownload() {
      return this.$common.confirm('是否确认导出')
        .then(() => sysGoodsApi.exportExcel(this.query))
    },
  }
}
</script>
